// styles
import s from './Spinner.sss';

// types
type SpinnerProps = {
  size?: number;
};

export const Spinner: React.FC<SpinnerProps> = ({ size }) => (
  <div className={s.wrapper}>
    <div
      className={s.root}
      style={{ fontSize: `${size}px` }}
    />
  </div>
);

Spinner.defaultProps = {
  size: 4,
};

export default Spinner;
